export const randomStr = function (n) {
  const str = 'abcdefghijklmnopqrstuvwxyz9876543210'
  let tmp = ''
  let i = 0
  const l = str.length
  for (i = 0; i < n; i++) {
    tmp += JSON.parse(JSON.stringify(Math.floor(Math.random() * l))[0])
  }
  return tmp
}

export const generateRefId = () => {
  return (
    randomStr(8) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(12)
  )
}

export const generateClassId = () => {
  return 'random_' + randomStr(12)
}
